// extracted by mini-css-extract-plugin
export default {"cluster-screen":"Landmarks_cluster-screen__ue3-I","full-width":"Landmarks_full-width__RdOdz","calc-width":"Landmarks_calc-width__uoJEh","mapWrapper":"Landmarks_mapWrapper__E0SOc"};